import './Table.css'
import cx from 'classnames'
export { TableColumnHeader, TableColumnGroupHeader } from './TableColumnHeader'
export { TableRow } from './TableRow'
export { TableCell } from './TableCell'
export { TableFooterCell } from './TableFooterCell'
export { TableRowHeader } from './TableRowHeader'
export { TableDivider } from './TableDivider'

export function Table({
  children,
  className,
  borderless,
  dense,
  superDense
}: {
  children: React.ReactNode
  className?: string
  dense?: boolean
  borderless?: boolean
  superDense?: boolean
}) {
  return (
    <table
      className={cx('table-base group/table', className, {
        'table-borderless': borderless,
        dense: dense,
        superDense: superDense
      })}
    >
      {children}
    </table>
  )
}
